import { call, put, takeEvery } from 'redux-saga/effects'
import {
  //getUser
  getUserData,
  getUserDataSuccess,
  getUserDataFailure,

  // User Details
  getUserDetailsListApiData,
  getUserDetailsListApiSuccess,
  getUserDetailsListApiFailure,

  // Store List
  storeListApiData,
  getStoreListApiSuccess,
  getStoreListApiFailure,

  // store Details
  getStoreDetailsListApiData,
  getStoreDetailsListApiSuccess,
  getStoreDetailsListApiFailure,

  // add store By Admin
  addStoreByAdminApiData,
  addStoreByAdminApiSuccess,
  addStoreByAdminApiFailure,

  // Delete Store Data
  deleteStoreApiData,
  deleteStoreApiSuccess,
  deleteStoreApiFailure,

  // Status Active
  activateStoreApiData,
  activateStoreApiSuccess,
  activateStoreApiFailure,
  // Status DeActive
  deActiveStoreApiData,
  deActiveStoreApiSuccess,
  deActiveStoreApiFailure,

  // Add Bulk Store
  addBulkStoreByExcelApiData,
  addBulkStoreByExcelApiSuccess,
  addBulkStoreByExcelApiFailure,

  // company
  companyListApiData,
  companyListApiSuccess,
  companyListApiFailure,

  // Company Details
  companyDetailsListApiData,
  companyDetailsListApiSuccess,
  companyDetailsListApiFailure,

  // Add  Company
  addCompanyByAdminApiData,
  addCompanyByAdminApiSuccess,
  addCompanyByAdminApiFailure,

  // Update Company
  updateCompanyByAdminApiData,
  updateCompanyByAdminApiSuccess,
  updateCompanyByAdminApiFailure,
  // Delete
  deleteCompanyApiData,
  deleteCompanyApiSuccess,
  deleteCompanyApiFailure,

  // Active Company
  activateCompanyApiData,
  activateCompanyApiSuccess,
  activateCompanyApiFailure,

  // DeActive Company
  deActiveCompanyApiData,
  deActivateCompanyApiSuccess,
  deActivateCompanyApiFailure,

  // distributor
  distributorListApiData,
  distributorListApiSuccess,
  distributorListApiFailure,

  // distributor Details
  distributorDetailsListApiData,
  distributorDetailsListApiSuccess,
  distributorDetailsListApiFailure,

  // distributor Company
  addDistributorByAdminApiData,
  addDistributorByAdminApiSuccess,
  addDistributorByAdminApiFailure,

  // distributor Company
  updateDistributorByAdminApiData,
  updateDistributorByAdminApiSuccess,
  updateDistributorByAdminApiFailure,
  // Delete distributor
  deleteDistributorApiData,
  deleteDistributorApiSuccess,
  deleteDistributorApiFailure,

  // Active distributor
  activateDistributorApiData,
  activateDistributorApiSuccess,
  activateDistributorApiFailure,

  // DeActive distributor
  deActiveDistributorApiData,
  deActivateDistributorApiSuccess,
  deActivateDistributorApiFailure,

  // update Store
  updateStoreByAdminApiData,
  updateStoreByAdminApiSuccess,
  updateStoreByAdminApiFailure,
} from './slice'
import { API } from '../../services'

//User
function* getUser({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.userListApi, payload)
    if (response.data && response.status === 200) {
      yield put(getUserDataSuccess({ payload: response?.data }))
    } else {
      yield put(getUserDataFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(getUserDataFailure({ message: error?.message }))
  }
}
function* getUserDetailsListApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.getUserDetailsList, payload)
    if (response.data && response.status === 200) {
      yield put(getUserDetailsListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getUserDetailsListApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(getUserDetailsListApiFailure({ message: error?.message }))
  }
}
function* storeListApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.storeList, payload)
    if (response.data && response.status === 200) {
      yield put(getStoreListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getStoreListApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreListApiFailure({ message: error?.message }))
  }
}
function* getStoreDetailsListApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.getStoreDetailsList, payload)
    if (response.data && response.status === 200) {
      yield put(getStoreDetailsListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getStoreDetailsListApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreDetailsListApiFailure({ message: error?.message }))
  }
}
function* addStoreByAdminApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addStoreByAdmin, payload)
    if (response.data && response.status === 200) {
      yield put(addStoreByAdminApiSuccess({ payload: response?.data }))
    } else {
      yield put(addStoreByAdminApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(addStoreByAdminApiFailure({ message: error?.message }))
  }
}
function* updateStoreByAdminApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.updateStoreByAdmin, payload)
    if (response.data && response.status === 200) {
      yield put(updateStoreByAdminApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateStoreByAdminApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreByAdminApiFailure({ message: error?.message }))
  }
}
function* deleteStoreApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deleteStore, payload)
    if (response.data && response.status === 200) {
      yield put(deleteStoreApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteStoreApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteStoreApiFailure({ message: error?.message }))
  }
}
function* activateStoreApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.activateStore, payload)
    if (response.data && response.status === 200) {
      yield put(activateStoreApiSuccess({ payload: response?.data }))
    } else {
      yield put(activateStoreApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(activateStoreApiFailure({ message: error?.message }))
  }
}
function* deActiveStoreApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deActiveStore, payload)
    if (response.data && response.status === 200) {
      yield put(deActiveStoreApiSuccess({ payload: response?.data }))
    } else {
      yield put(deActiveStoreApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(deActiveStoreApiFailure({ message: error?.message }))
  }
}

function* addBulkStoreByExcelApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addBulkStoreByExcel, payload)
    if (response.data && response.status === 200) {
      yield put(addBulkStoreByExcelApiSuccess({ payload: response?.data }))
    } else {
      yield put(addBulkStoreByExcelApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(addBulkStoreByExcelApiFailure({ message: error?.message }))
  }
}
function* companyListApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.companyList, payload)
    if (response.data && response.status === 200) {
      yield put(companyListApiSuccess({ payload: response?.data }))
    } else {
      yield put(companyListApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(companyListApiFailure({ message: error?.message }))
  }
}
function* companyDetailsListApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.getCompanyDetailsList, payload)
    if (response.data && response.status === 200) {
      yield put(companyDetailsListApiSuccess({ payload: response?.data }))
    } else {
      yield put(companyDetailsListApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(companyDetailsListApiFailure({ message: error?.message }))
  }
}
function* addCompanyByAdminApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addCompanyByAdmin, payload)
    if (response.data && response.status === 200) {
      yield put(addCompanyByAdminApiSuccess({ payload: response?.data }))
    } else {
      yield put(addCompanyByAdminApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(addCompanyByAdminApiFailure({ message: error?.message }))
  }
}
function* updateCompanyByAdminApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.updateCompanyByAdmin, payload)
    if (response.data && response.status === 200) {
      yield put(updateCompanyByAdminApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateCompanyByAdminApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(updateCompanyByAdminApiFailure({ message: error?.message }))
  }
}
function* deleteCompanyApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deleteCompany, payload)
    if (response.data && response.status === 200) {
      yield put(deleteCompanyApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteCompanyApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteCompanyApiFailure({ message: error?.message }))
  }
}
function* activateCompanyApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.activateCompany, payload)
    if (response.data && response.status === 200) {
      yield put(activateCompanyApiSuccess({ payload: response?.data }))
    } else {
      yield put(activateCompanyApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(activateCompanyApiFailure({ message: error?.message }))
  }
}
function* deActiveCompanyApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deActiveCompany, payload)
    if (response.data && response.status === 200) {
      yield put(deActivateCompanyApiSuccess({ payload: response?.data }))
    } else {
      yield put(deActivateCompanyApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(deActivateCompanyApiFailure({ message: error?.message }))
  }
}
function* distributorListApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.distributorList, payload)
    if (response.data && response.status === 200) {
      yield put(distributorListApiSuccess({ payload: response?.data }))
    } else {
      yield put(distributorListApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(distributorListApiFailure({ message: error?.message }))
  }
}
function* distributorDetailsListApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.getDistributorDetailsList, payload)
    if (response.data && response.status === 200) {
      yield put(distributorDetailsListApiSuccess({ payload: response?.data }))
    } else {
      yield put(distributorDetailsListApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(distributorDetailsListApiFailure({ message: error?.message }))
  }
}
function* addDistributorByAdminApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.addDistributorByAdmin, payload)
    if (response.data && response.status === 200) {
      yield put(addDistributorByAdminApiSuccess({ payload: response?.data }))
    } else {
      yield put(addDistributorByAdminApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(addDistributorByAdminApiFailure({ message: error?.message }))
  }
}
function* updateDistributorByAdminApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.updateDistributorByAdmin, payload)
    if (response.data && response.status === 200) {
      yield put(updateDistributorByAdminApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateDistributorByAdminApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(updateDistributorByAdminApiFailure({ message: error?.message }))
  }
}
function* deleteDistributorApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deleteDistributor, payload)
    if (response.data && response.status === 200) {
      yield put(deleteDistributorApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteDistributorApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteDistributorApiFailure({ message: error?.message }))
  }
}
function* activateDistributorApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.activateDistributor, payload)
    if (response.data && response.status === 200) {
      yield put(activateDistributorApiSuccess({ payload: response?.data }))
    } else {
      yield put(activateDistributorApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(activateDistributorApiFailure({ message: error?.message }))
  }
}
function* deActiveDistributorApi({ type, payload }) {
  try {
    const response = yield call(API.providerManagementApi.deActiveDistributor, payload)
    if (response.data && response.status === 200) {
      yield put(deActivateDistributorApiSuccess({ payload: response?.data }))
    } else {
      yield put(deActivateDistributorApiFailure({ message: response.message }))
    }
  } catch (error) {
    yield put(deActivateDistributorApiFailure({ message: error?.message }))
  }
}

function* providerManagementSaga() {
  //user
  yield takeEvery(getUserData, getUser)
  yield takeEvery(getUserDetailsListApiData, getUserDetailsListApi)
  yield takeEvery(storeListApiData, storeListApi)
  yield takeEvery(getStoreDetailsListApiData, getStoreDetailsListApi)
  yield takeEvery(addStoreByAdminApiData, addStoreByAdminApi)
  yield takeEvery(updateStoreByAdminApiData, updateStoreByAdminApi)
  yield takeEvery(deleteStoreApiData, deleteStoreApi)
  yield takeEvery(activateStoreApiData, activateStoreApi)
  yield takeEvery(deActiveStoreApiData, deActiveStoreApi)
  yield takeEvery(addBulkStoreByExcelApiData, addBulkStoreByExcelApi)
  yield takeEvery(companyListApiData, companyListApi)
  yield takeEvery(companyDetailsListApiData, companyDetailsListApi)
  yield takeEvery(addCompanyByAdminApiData, addCompanyByAdminApi)
  yield takeEvery(updateCompanyByAdminApiData, updateCompanyByAdminApi)
  yield takeEvery(deleteCompanyApiData, deleteCompanyApi)
  yield takeEvery(activateCompanyApiData, activateCompanyApi)
  yield takeEvery(deActiveCompanyApiData, deActiveCompanyApi)
  yield takeEvery(distributorListApiData, distributorListApi)
  yield takeEvery(distributorDetailsListApiData, distributorDetailsListApi)
  yield takeEvery(addDistributorByAdminApiData, addDistributorByAdminApi)
  yield takeEvery(updateDistributorByAdminApiData, updateDistributorByAdminApi)
  yield takeEvery(deleteDistributorApiData, deleteDistributorApi)
  yield takeEvery(activateDistributorApiData, activateDistributorApi)
  yield takeEvery(deActiveDistributorApiData, deActiveDistributorApi)
}

export default providerManagementSaga
